"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var alert_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/alert"));
var AlertStore = /** @class */ (function () {
    function AlertStore(props) {
        var _this = this;
        this.component = alert_1.default;
        this.clear = function () {
            _this.alertText = undefined;
        };
        this.alertText = props.text;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AlertStore.prototype, "alertText", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AlertStore.prototype, "clear", void 0);
    return AlertStore;
}());
exports.default = AlertStore;
